import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loginfaill',
  templateUrl: './loginfaill.component.html',
  styleUrls: ['./loginfaill.component.scss']
})
export class LoginfaillComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
